import React from 'react';
import { ChevronDown, FileSpreadsheet, FileText, FileType, FolderOpen } from 'lucide-react';

const SECTION_ICONS = {
  excel: FileSpreadsheet,
  word: FileText,
  pdf: FileType,
  other: FolderOpen,
};

export const DocumentSectionHeader = ({ id, title, count, colorClass, isExpanded, onToggle }) => {
  const Icon = SECTION_ICONS[id] || FolderOpen;

  return (
    <button
      type="button"
      onClick={onToggle}
      className="w-full text-left bg-white flex items-center justify-between px-4 py-2.5 transition-all duration-300 hover:bg-slate-50"
    >
      <div className="flex items-center gap-4">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colorClass}`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex items-center gap-2">
          <h3 className="font-serif font-medium text-base text-slate-900 tracking-wide">{title}</h3>
          <span className="text-sm font-semibold text-slate-400">({count})</span>
        </div>
      </div>
      <div className="flex items-center">
        <ChevronDown
          className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
        />
      </div>
    </button>
  );
};
